import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SectionFormType, StrategyStepConfiguration } from "src/types/strategy";
import { SECTION_KEYS } from "src/consts";

export const useStrategySteps = (): StrategyStepConfiguration[] => {
  useTranslation();

  return useMemo(
    () => [
      {
        title: "What is your brand?",
        description: "",
        example: "",
        sectionKey: SECTION_KEYS.BRAND_DETAILS,
        hasInstruction: false,
        formType: SectionFormType.LongText,
      },
      {
        title: "👑 Для кого твій контент?",
        description:
          "Давай спробуємо розібратись, хто твоя цільова аудиторія. Я тобі генеруватиму варіанти. Ти можеш обирати з мого списку, редагувати його або ж доповнювати своїм. <br/> Максимальна кількість варіантів - 3.",
        sectionKey: SECTION_KEYS.TARGET_AUDIENCE,
        hasInstruction: true,
        options: { maxItems: 3 },
        formType: SectionFormType.List,
      },
    ],
    []
  );
};
